import { Row, Col, Card, Icon, Form, Input, Select, DatePicker } from 'antd';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { security } from './formConfig';
import { FaqModal } from '@bit/ui-common.ui-components/ss-common-data';

const
config = security,
{ key } = config,
{ generateFormItem, generateInputComponent, generateOptionFromCommonData } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils;

export default class Security extends React.Component {
    state = { isValid: false }
    constructor(props) { super(props); }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        form = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, form)) {
            const formState = validateForm(form, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    setMaxWidth = d => ({...d, style: { width: '100%' }});

    render() {
        const
        { services, registrationForm } = this.props,
        form = registrationForm[key],
        { storeForm, storeFormField, toggleHelpFaqModal } = services;

        return (
            <div>
                <FaqModal />
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={16}>
                        <Card hoverable style={{ cursor: 'default' }} bodyStyle={{ padding: '10px', lineHeight: '18px' }}>
                            <div style={{ marginBottom: '20px' }}>
                                <span style={{ fontWeight: 'bold' }}>
                                    <Icon type='info-circle-o' style={{ marginRight: '6px' }} />
                                    {'Instructions: '}
                                </span>
                                <div>
                                    {'Please answer the 3 security questions below and type your responses in the boxes provided.'}
                                </div>
                            </div>
                            <div style={{ marginBottom: '35px' }}>
                                <span style={{ fontWeight: 'bold' }}>
                                    <Icon type='info-circle-o' style={{ marginRight: '6px' }} />
                                    {'Tips: '}
                                </span>

                                <div>
                                    <br/>
                                    <ul>
                                        <li>{'Choose answers that you can easily remember. (If you are a professional pilot, you may be using these answers over 30-40 years of your career.)'}</li>
                                        <li>{'TSA personnel will not be able to supply these answers if you forget them.'}</li>
                                        <li>{'If you forget your login information and no longer have access to the email address on file,'}
                                            {' you can change your email address online after correctly answering the security questions.'}
                                        </li>
                                        <li>{'For more information, see '}
                                            <a href="/home/help?view=c&tab=faqs" target="_blank">
                                                {'Frequently Asked Questions (FAQ)'}
                                            </a>
                                            {'.'}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={16}>
                        <Form>
                            <Row type='flex' justify='space-around' align='middle' gutter={10}>
                                <Col span={8}>
                                    <Form.Item {...generateFormItem('q1', config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('q1', config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item {...generateFormItem('q2', config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('q2', config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item {...generateFormItem('q3',  config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('q3', config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}
